import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { businessProfileStyles } from "styles/BusinessDirectory/businessProfile.styles";
import AvailabilityCard from "./AvailabilityCard";
import DatePickerModal from "./DatePickerModal";
import FareharborAvailabilityCard from "./FareharborAvailabilityCard";

interface Availability {
  start_time: string;
  end_time: string;
}

interface Item {
  availabilities: Availability[];
}



const Availabilities = ({
  items,
  date,
  setDate,
  referredBy,
  isLoadingAvailabilities,
}: any) => {
  const theme = useTheme();

  const formattedDate = dayjs(date).format("ddd, MMM D, YYYY");

  const urlParams = new URLSearchParams(window.location.search);
  const showDetails = urlParams.get("showDetails");

  const [isCalendarVisible, setIsCalendarVisible] = useState(false);

  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      // Use dayjs to format the date and set it
      const formattedDate = date.format("YYYY-MM-DD");
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("date", formattedDate);
      window.history.pushState(
        {},
        "",
        `${window.location.pathname}?${searchParams.toString()}`
      );
      setDate(date);
      setIsCalendarVisible(false);
    }
  };

  const isScreenBreak = useMediaQuery("(max-width: 842px)");

  return (
    <Box
      sx={[
        businessProfileStyles.outerContainer,
        { fontFamily: theme.typography.fontFamily },
      ]}
    >
      {/* Heading */}
      {showDetails === "all" && (
        <Typography sx={businessProfileStyles.availabilitiesHeading}>
          Availabilities
        </Typography>
      )}

      <Box
        width={"fit-content"}
        mb={1}
        display="flex"
        flexDirection={"column"}
        border="none"
        sx={businessProfileStyles.datePickerContainer}
      >
        <DatePickerModal
          date={date}
          handleDateChange={handleDateChange}
          isCalendarVisible={isCalendarVisible}
          setIsCalendarVisible={setIsCalendarVisible}
        />
      </Box>

      {isLoadingAvailabilities ? (
        <Box
          sx={businessProfileStyles.loadingAvailabilitiesContainer}
        >
          <CircularProgress size={32} />
        </Box>
      ) : (
        <>
          {items?.length === 0 ? (
            <Box sx={businessProfileStyles.noFoundContainer}>
              <Typography sx={businessProfileStyles.noFoundContainer}>
                No availabilities found for {formattedDate}.
              </Typography>
            </Box>
          ) : (
            <Box
              sx={businessProfileStyles.availabilityContainer(isScreenBreak)}
            >
              {items?.length > 0 ? (
                items?.map((item: any, index: number) => (
                  <Box
                    key={index}
                    sx={businessProfileStyles.availabilityItemWrapper(isScreenBreak, items.length)}
                  >
                    {item?.item_type === 1 && (
                      <AvailabilityCard item={item} referredBy={referredBy} />
                    )}

                    {item?.item_type === 3 && (
                      <AvailabilityCard item={item} referredBy={referredBy} />
                    )}

                    {item?.item_type === 4 &&
                      item.fareharbor_availabilities !== undefined &&
                      item.fareharbor_availabilities !== null &&
                      item.fareharbor_availabilities.length > 0 && (
                        <FareharborAvailabilityCard
                          item={item}
                          referredBy={referredBy}
                          screenName="Business"
                        />
                      )}
                  </Box>
                ))
              ) : (
                <Typography>No Record Found </Typography>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default Availabilities;
